import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/edge-gateways/")({
  staticData: {
    title: "edge.navigation.edgeGateways",
  },
});
